import api from "../utils/api";

/**
 * Fetch power-quality & energy insights for the Historical → Insights tab.
 *
 * @param {Object} params
 * @param {string} [params.username]  client username (scope)
 * @param {string} [params.machine]   machine name or "All"
 * @param {string} [params.severity]  "Critical" | "Warning" | "All"
 * @param {string} [params.category]  category name or "All"
 * @param {string} [params.from]      range start (yyyy-mm-dd)
 * @param {string} [params.to]        range end (yyyy-mm-dd)
 * @returns {Promise<{insights:Array, categories:string[], machines:string[], summary:Object}>}
 */
export const getInsights = async (params = {}) => {
  const query = {};
  if (params.username) query.username = params.username;
  if (params.machine) query.machine = params.machine;
  if (params.severity) query.severity = params.severity;
  if (params.category) query.category = params.category;
  if (params.from) query.from = params.from;
  if (params.to) query.to = params.to;

  const response = await api.get("/insights", { params: query });
  const data = response.data || {};
  return {
    insights: data.insights || [],
    categories: data.categories || [],
    machines: data.machines || [],
    summary: data.summary || {
      totalLoss: 0,
      totalCost: 0,
      totalSavings: 0,
      criticalCount: 0,
      warningCount: 0,
    },
  };
};
